export default "__VITE_ASSET__Bdj5H14G__"